import { BarChartOutlined, RightOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import type { ReportMeta } from "@wms/domain";
import { Button, Col, Result, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { LoadProblem } from "../components/LoadProblem";
import { PageHeader } from "../components/PageHeader";

export function ReportsPage() {
  const reports = useQuery({ queryKey: ["reports"], queryFn: () => api.get<ReportMeta[]>("/reports") });
  const groups = new Map<string, ReportMeta[]>();
  for (const r of reports.data ?? []) groups.set(r.group, [...(groups.get(r.group) ?? []), r]);
  if (reports.isError) return <LoadProblem error={reports.error} />;
  return (
    <div>
      <PageHeader title="Отчёты" subtitle="Каждый отчёт открывается с параметрами и выгружается в Excel или CSV" />
      {reports.data && reports.data.length === 0 && (
        <Result
          status="403"
          title="Отчёты недоступны вашей роли"
          subTitle="Права на отчёты выдаёт руководитель или администратор. Остатки по товарам и ячейкам смотрите в разделе «Склад»."
          extra={
            <Link to="/dashboard">
              <Button type="primary">На рабочий стол</Button>
            </Link>
          }
        />
      )}
      {[...groups.entries()].map(([group, items]) => (
        <div key={group} style={{ marginBottom: 26 }}>
          <Typography.Text strong style={{ display: "block", marginBottom: 10, fontSize: 13, textTransform: "uppercase", letterSpacing: ".04em", color: "var(--wms-muted)" }}>
            {group}
          </Typography.Text>
          <Row gutter={[12, 12]}>
            {items.map((r) => (
              <Col key={r.code} xs={24} sm={12} lg={8}>
                <Link to={`/reports/${r.code}`} className="wms-hub-card" style={{ alignItems: "flex-start", height: "100%" }}>
                  <span style={{ display: "flex", gap: 12, minWidth: 0 }}>
                    <span style={{ width: 36, height: 36, borderRadius: 10, background: "var(--wms-primary-soft)", color: "var(--wms-primary)", display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 16 }}>
                      <BarChartOutlined />
                    </span>
                    <span style={{ minWidth: 0 }}>
                      <span style={{ display: "block", fontWeight: 600 }}>{r.name}</span>
                      <span style={{ display: "block", color: "var(--wms-muted)", fontSize: 12, marginTop: 2 }}>{r.description}</span>
                    </span>
                  </span>
                  <RightOutlined style={{ color: "var(--wms-muted)", fontSize: 12, marginTop: 4 }} />
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </div>
  );
}
